import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { customTheme } from "../../../../../../config/theme/MuiTheme";
import useOperationTranslation from "../../../../hooks/useOperationTranslation";
import { CreateDamageFormTypes } from "../../Types";
import OperationTypes from "../../../../types";
import { useMemo } from "react";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    parts: OperationTypes.VehiclePart[];
    damage?: CreateDamageFormTypes.IRespCreateDamage;
    onDelete: () => void;
  }
const DeleteConfirmation = (props: Props) => {
  const t = useOperationTranslation();

  const selectedPart = useMemo(() => {
    if (!props.damage) return "";

    return props.parts.find((part) => part.part.id === props.damage?.partId && part.position.id === props.damage.partPositionId)?.label || "";
  }, [props.damage]);

    return(
        <Mui.Dialog 
          maxWidth="sm"
          fullWidth
          open={props.isOpen}
          onClose={props.onClose}
        >
          <Mui.DialogTitle>
            <Mui.Grid container columnSpacing={1}>
              <Mui.Grid item xs="auto" color={customTheme.palette.accent.main}>
                <MuiIcons.Info color="inherit" />
              </Mui.Grid>

              <Mui.Grid item xs="auto">
                <Mui.Typography variant="h5">
                {t("damageForm.damageFormCreation.dialogs.deleteConfirmation.title")}
                </Mui.Typography>
              </Mui.Grid>

              <Mui.Grid item xs="auto" marginLeft="auto">
                <Mui.IconButton onClick={props.onClose}>
                  <MuiIcons.Close />
                </Mui.IconButton>
              </Mui.Grid>
            </Mui.Grid>
          </Mui.DialogTitle>

          <Mui.DialogContent>
            <Mui.Grid container>
              <Mui.Grid item xs={12}>
                <Mui.Typography
                  variant="bodySmall"
                  color="#18305B"
                  style={{ whiteSpace: "pre-line" }}
                >
                  {t("damageForm.damageFormCreation.dialogs.deleteConfirmation.body1").replace("#textElement", selectedPart)}
                </Mui.Typography>
              </Mui.Grid>

              <Mui.Grid item xs={12}>
                <Mui.Typography
                  variant="bodySmall"
                  color="#18305B"
                  style={{ whiteSpace: "pre-line" }}
                >
                  {t("damageForm.damageFormCreation.dialogs.deleteConfirmation.body2")}
                </Mui.Typography>
              </Mui.Grid>
            </Mui.Grid>
          </Mui.DialogContent>

          <Mui.DialogActions>
            <Mui.Button variant="outlined" onClick={props.onClose}>
              {t("damageForm.damageFormCreation.button.cancel")}
            </Mui.Button>

            <Mui.Button variant="contained" onClick={props.onDelete}>
              {t("damageForm.damageFormCreation.button.delete")}
            </Mui.Button>
          </Mui.DialogActions>
        </Mui.Dialog>
    )
}
export default DeleteConfirmation;